import type { OnInit } from '@angular/core';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DownloadXlsxService } from '../../../shared/services/download-xlsx.service';
import { ErrorHandlerService } from '../../../shared/services/error-handler.service';
import { FmLoadingPageService } from '../../../shared/services/fm-loading-page.service';
import { ReportServiceService } from '../report-service.service';

@Component({
  standalone: false,
  selector: 'invd-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss'],
})
export class ContactListComponent implements OnInit {
  stContactData: any;
  showDealer = true;
  showOrg = false;
  contactDetails: any;
  orgDetails: any;

  private reportService = inject(ReportServiceService);
  public fmLoadingPageService = inject(FmLoadingPageService);
  private downloadXlsxService = inject(DownloadXlsxService);
  private errorHandlerService = inject(ErrorHandlerService);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);

  ngOnInit() {
    this.runReport();
  }

  private handleSTContactReportSuccess(data: any) {
    this.stContactData = data;
    this.contactDetails = data.stContactDetails;
    this.orgDetails = data.stOrgDetails;
    this.fmLoadingPageService.isLoaderRequesting.set(false);
    this.cdr.markForCheck();
  }

  downloadReport() {
    this.downloadXlsxService.generateContactReportExcel(this.stContactData);
  }

  private handleSTContactReportServiceFail(error: any) {
    this.fmLoadingPageService.isLoaderRequesting.set(false);
    const errorObject = error.error;
    if (errorObject.statusCode === 400 || errorObject.statusCode === 500) {
      this.errorHandlerService.setErrorObj(errorObject);
      this.router.navigate(['error']);
    }
    this.cdr.markForCheck();
  }

  runReport() {
    this.fmLoadingPageService.isLoaderRequesting.set(true);
    this.reportService.stContactDetailsReport().subscribe({
      next: (data) => this.handleSTContactReportSuccess(data),
      error: (error) => this.handleSTContactReportServiceFail(error),
    });
  }

  showDealerSelection() {
    this.showDealer = true;
    this.showOrg = false;
  }

  showOrgSelection() {
    this.showDealer = false;
    this.showOrg = true;
  }

  protected sortByGridByColumnName(_column: string) {}

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
